import { useQuery } from 'react-query'
import RequestService from '../../services/request/request-service'
import { INCLUDE_INACTIVE_FLAG } from '../constants/general'
import { OUTLET_QUERY } from '../constants/queries'

const useOutletQuery = ({ showActive = true, page = 0, pageZize = 10000, filter = { id_location: 0 } } = {}) => {
  return useQuery({
    queryKey: [OUTLET_QUERY, showActive, page, pageZize, filter],
    queryFn: async ({ queryKey }) => {
      let url = `${queryKey[0]}?${!queryKey[1] ? INCLUDE_INACTIVE_FLAG : ''}&startRowIndex=${queryKey[2]}&pageSize=${
        queryKey[3]
      }`
      if (filter?.id_location) {
        url = `${url}&id_location=${filter.id_location}`
      }
      const { data } = await RequestService.Get(url)
      return data
    },
    initialData: [],
  })
}
export default useOutletQuery
